export default __webpack_public_path__ + "static/tech-4-49c72e0ced26438979310b8f46502dd5.jpg";